export default __webpack_public_path__ + "static/media/message.45074e39.png";